import { useState } from 'react'
import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '../../auth/AuthProvider'
import { usePermissions } from '../../auth/usePermissions'
import { IconChat, IconChevronDown, IconDocument, IconLogout, IconSettings } from '../ui/Icon'
import { PageHeaderProvider, useCurrentPageHeader } from './PageHeaderContext'

export function AppLayout() {
  const { canSearch, canApprove } = usePermissions()
  // 削除申請は Ask / 詳細のモーダル本線。サイドナビは承認キューのみ。
  const brandTo = canSearch ? '/rag/chat' : canApprove ? '/rag/documents' : '/'

  return (
    <PageHeaderProvider>
      <div className="app-shell">
        <aside className="app-sidebar">
          <Link to={brandTo} className="app-sidebar-brand">
            <span className="app-sidebar-brand-mark" aria-hidden="true">
              丸
            </span>
            <span className="app-sidebar-brand-label">Maruya RAG</span>
          </Link>

          <nav className="app-nav" aria-label="メインナビゲーション">
            {canSearch && (
              <NavLink to="/rag/chat" className="app-nav-link">
                <IconChat />
                <span>AI 質問</span>
              </NavLink>
            )}
            {canApprove && (
              <NavLink to="/rag/documents" className="app-nav-link">
                <IconDocument />
                <span>承認待ち</span>
              </NavLink>
            )}
          </nav>
        </aside>

        <div className="app-main">
          <Topbar />
          <Outlet />
        </div>
      </div>
    </PageHeaderProvider>
  )
}

function Topbar() {
  const { me, logout } = useAuth()
  const { canManageRpaCredentials } = usePermissions()
  const { eyebrow, title } = useCurrentPageHeader()
  const [menuOpen, setMenuOpen] = useState(false)
  const navigate = useNavigate()

  const displayName = me?.user.display_name || me?.user.email || ''
  const initial = displayName.trim().charAt(0).toUpperCase() || '?'
  const roleName = me?.role?.name ?? me?.user.role_id

  return (
    <header className="app-topbar">
      <div className="app-topbar-heading">
        {eyebrow && <p className="eyebrow app-topbar-eyebrow">{eyebrow}</p>}
        <h1 className="app-topbar-title">{title}</h1>
      </div>

      <div className="app-user-chip-wrap">
        <button
          type="button"
          className="app-user-chip"
          onClick={() => setMenuOpen((open) => !open)}
          aria-expanded={menuOpen}
        >
          <span className="app-user-chip-avatar" aria-hidden="true">
            {initial}
          </span>
          <span className="app-user-chip-info">
            <span className="user-label">{displayName}</span>
            {roleName && <span className="user-role">{roleName}</span>}
          </span>
          <IconChevronDown className="app-user-chip-caret" />
        </button>

        {menuOpen && (
          <>
            <div className="app-user-menu-backdrop" onClick={() => setMenuOpen(false)} />
            <div className="app-user-menu">
              {canManageRpaCredentials && (
                <button
                  type="button"
                  className="app-user-menu-item"
                  onClick={() => {
                    setMenuOpen(false)
                    navigate('/settings/rpa-credentials')
                  }}
                >
                  <IconSettings />
                  RPA連携アカウント
                </button>
              )}
              <button
                type="button"
                className="app-user-menu-item"
                onClick={() => void logout()}
              >
                <IconLogout />
                ログアウト
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  )
}
